import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';

export class GaiaIdStore extends Store {
  @observable public gaiaId?: string;
  @observable public gaiaIds?: string[];

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
